import {
    useContext,
    type FC
} from "react";
import {
    View
} from "react-native";
import type IDropdownMenuMarkProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    getTypeColors
} from "../../../../helpers/theme/typeColors";
import {
    Minus as MinusIcon,
    Check as CheckIcon
} from "lucide-react-native";
import {
    DropdownMenuContext
} from "../../context";

const DropdownMenuMark: FC<IDropdownMenuMarkProps> = ({
    customTheme: customThemeProp,
    isDisabled = false,
    isChecked,
    kind
}) => {
    const context = useContext(DropdownMenuContext);

    const {
        iconSizes,
        radiuses,
        colors
    } = NCoreUIKitTheme.useContext(customThemeProp ?? context?.customTheme);

    const color = isDisabled ? getTypeColors({
        variant: "ghost",
        type: "neutral",
        isDisabled,
        colors
    }).iconColor : colors.content.icon.high;

    const {
        slot: slotDynamicStyle,
        dot: dotDynamicStyle
    } = useStyles({
        iconSizes,
        radiuses,
        color
    });

    const renderMark = () => {
        if(!isChecked) {
            return null;
        }

        if(kind === "radio") {
            return <View
                style={dotDynamicStyle}
            />;
        }

        const Icon = isChecked === "partially" ? MinusIcon : CheckIcon;

        return <Icon
            size={iconSizes.small}
            color={color}
        />;
    };

    return <View
        style={[
            stylesheet.slot,
            slotDynamicStyle
        ]}
        aria-hidden={true}
    >
        {renderMark()}
    </View>;
};
export default DropdownMenuMark;
